import React from 'react'
import { useIntl } from 'react-intl'
import { Typography } from '@mui/material'

import { LoginFormComponent } from '../../../features/login'
import { ReactComponent as LogoNedgiaFull } from '../../../resources/images/logo_nedgia_full.svg'
import {
  LoginContainer,
  BackgroundSection,
  FormSection,
  CenteredContainer,
  LoginPanel,
  LogoContainer,
  TitleContainer,
  FormContainer,
} from './login.styles'

export const LoginPage = () => {
  const { formatMessage } = useIntl()

  return (
    <LoginContainer>
      <BackgroundSection />
      <FormSection>
        <CenteredContainer maxWidth="sm">
          <LoginPanel>
            <LogoContainer>
              <LogoNedgiaFull
                style={{
                  width: 233,
                  height: 104,
                }}
              />
            </LogoContainer>
            <TitleContainer>
              <Typography variant="h4">
                {formatMessage({ id: 'pages.login.title' })}
              </Typography>
            </TitleContainer>
            <FormContainer>
              <LoginFormComponent />
            </FormContainer>
          </LoginPanel>
        </CenteredContainer>
      </FormSection>
    </LoginContainer>
  )
}
